export const PUBLIC_URL = process.env.PUBLIC_URL;
export const URL_API = 'https://my-json-server.typicode.com/susird/desarrollador-m3-prueba/products';


